/**
 * @author Vaibhav <vaibhav.mane@314ecorp.com>
 * @description Faro initialization
 */

import {
	initializeFaro as coreInit,
	getWebInstrumentations,
	FetchTransport,
	browserMeta,
	TransportItem,
	Faro,
} from '@grafana/faro-react';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { getDefaultOTELInstrumentations, TracingInstrumentation } from '@grafana/faro-web-tracing';
import _ from 'lodash';

import config from 'configs/index';
import env from '@dexit/common/utils/Environment';

const isLocalhost = env.isLocalhost();
const Env = env.getEnvironment();

const URL_BLOCKLIST = [
	// remove in case of marker.io retired.
	'https://api.marker.io/',
	'https://collector.314ecorp.tech/',
	'https://edge.marker.io/',
	'https://fonts.googleapis.com/',
	'https://s3.eu-west-1.amazonaws.com/',
];

const URL_BLOCKLIST_REGEX = _.map(URL_BLOCKLIST, (url) => new RegExp(url.replace(/([.*+?^${}()|\\[\]])/g, '\\$1')));

const API_V1_REGEX = new RegExp('.*/api/v1/.*');

export const initializeFaro = (): Faro => {
	return coreInit({
		transports: [
			new FetchTransport({
				url: config.faro.url,
				apiKey: config.faro.apiKey,
				bufferSize: 1000,
				concurrency: 5,
				defaultRateLimitBackoffMs: 1000,
			}),
		],

		app: {
			name: 'Dexit-Web',
			version: '1.0.0',
			environment: Env,
		},
		instrumentations: [
			...getWebInstrumentations({
				captureConsole: true,
				captureConsoleDisabledLevels: [],
			}),
			new TracingInstrumentation({
				instrumentations: [
					...getDefaultOTELInstrumentations({
						propagateTraceHeaderCorsUrls: [API_V1_REGEX],
						ignoreUrls: URL_BLOCKLIST_REGEX,
					}),
					new FetchInstrumentation({
						propagateTraceHeaderCorsUrls: [API_V1_REGEX],
						ignoreUrls: URL_BLOCKLIST_REGEX,
					}),
					new XMLHttpRequestInstrumentation({
						propagateTraceHeaderCorsUrls: [API_V1_REGEX],
						ignoreUrls: URL_BLOCKLIST_REGEX,
					}),
				],
			}),
		],
		metas: [browserMeta],
		beforeSend: (item: TransportItem) => {
			if (isLocalhost) {
				return null;
			}
			delete item.meta.sdk;
			return item;
		},
	});
};
